import { Typography } from '@mui/material';
import { useAuth } from '../context/AuthProvider';
import ShopAdminRoutes from './shop-admin.routes';
import UserRoutes from './user.routes';

const PrivateRoutes = () => {
  const { user } = useAuth();

  return user?.role === 'user' ? (
    <UserRoutes />
  ) : user?.role === 'shop-admin' ? (
    <ShopAdminRoutes />
  ) : (
    <Typography>Todavía no soportamos el rol {user?.role}</Typography>
  );
};

export default PrivateRoutes;
